import { userAccountStore } from "@/store/loginStore";

export function authJwt(usrType) {
  const userData = userAccountStore();
  var token = null
  
  try {
    if (usrType == 'supper-user') {
      token = userData.supperUserToken;
    }else {
      token == '';
    }

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
          .join('')
      )
    )
    const currentTime = Math.floor(Date.now() / 1000);
    const isValid = jsonPayload.exp > currentTime ? true : false;
 
    return isValid;
  } catch (e) {
    return false;
  }
}
